var parameterInsert={
    IdUser:'',
    IdBranchOffice:'',
    TypeAccess:'', 
    Active:'1',
    User:'',
    IP:''
} 
var parameterUpdate={
    IdProfile:'', 
    TypeAccess:'', 
    Active:'1',
    User:'',
    IP:''
} 
var parameterView={ 
    IdEnterprise:'0',
    NameUser:'',  
    OfficenName:'', 
    Active:'2'
} 
export default
{
    parameterInsert,
    parameterUpdate,
    parameterView
}